import { configureStore } from '@reduxjs/toolkit'
import metadata from './features/metadata/MetadataLogic'

export const store = configureStore({
    reducer: {
        jsonMetadata: metadata,
    },
})